import Axios from "../api/axios";
import config from "../../config";

const getSupervisorList = () => {
  return Axios.get(`${config.BASE_URL}supervisor`);
};

export default getSupervisorList;
